// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginColl baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginColl",
  "tableName": "LoginColl",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "LOGO",
      "type": "IMG"
    },
    {
      "name": "LBL_USUARIO",
      "type": "TL",
      "title": "USUARIO"
    },
    {
      "name": "ICO_USUARIO",
      "type": "IMG"
    },
    {
      "name": "MAP_USUARIO",
      "type": "T"
    },
    {
      "name": "LBL_PASS",
      "type": "TL",
      "title": "CONTRASEÑA"
    },
    {
      "name": "ICO_PASS",
      "type": "IMG"
    },
    {
      "name": "MAP_PASSWORD",
      "type": "X"
    },
    {
      "name": "LBL_CO",
      "type": "TL",
      "title": "Aprosuba 3 Plena Inclusión de Badajoz"
    },
    {
      "name": "LBL_VER",
      "type": "TL",
      "title": "Versión: 16.06.2026.08"
    },
    {
      "name": "LOGO_RIGHT",
      "type": "IMG"
    },
    {
      "name": "LBL_TITULO_R",
      "type": "TL",
      "title": "Aprosuba 3"
    },
    {
      "name": "LBL_SUB_R",
      "type": "TL",
      "title": "Plena Inclusión de Badajoz"
    },
    {
      "name": "LBL_CITA",
      "type": "TL",
      "title": "\"Trabajamos por la inclusión de todos porque todos somos iguales.\""
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "special": true
} as const;
